import { useEffect, useState } from 'react';
import ReviewStars from '../../reviewStars/ReviewStars';
import ReactLoading from 'react-loading';
import EmptyPage from '../../empty-page/emptyPage';

const OrgActivityReviews = () => {
    const [reviews, setReviews] = useState([]);
    const [selectedActivity, setSelectedActivity] = useState('');
    const [loading, setLoading] = useState(false);
    const tableHeader = ['Activity Name', 'User Name', 'Rating', 'Comments'];

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, []);

    const getReviewStars = (rating) => {
        return (
            <div className='org_tripCardNumInfo'>
                <ReviewStars rating={rating} />
                <span>{rating ?? 'N/A'}</span>
            </div>
        );
    };

    return (
        <>
            {loading && (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            )}
            <div className='orgReviews'>
                <h2 className='orgReviewsHeading'>Reviews</h2>
                <div className='orgReviewFilter'>
                    <select
                        name='date'
                        id='date'
                        className='select mr-2'
                        onChange={(e) => setSelectedActivity(e.target.value)}
                    >
                        <option value=''>Select Activity</option>
                        {/* {trips.map((trip) => (
                            <option value={trip._id} key={trip._id}>
                                {trip.title}
                            </option>
                        ))} */}
                    </select>
                </div>
            </div>
            <div className='orgReviewsContainer'>
                {reviews?.length === 0 && !loading ? (
                    <EmptyPage />
                ) : (
                    <div className='tableContainer'>
                        <table className='table'>
                            <thead className='tableHead'>
                                <tr>
                                    {tableHeader.map((head, headIndex) => {
                                        return <th key={headIndex}>{head}</th>;
                                    })}
                                </tr>
                            </thead>
                            <tbody>
                                {reviews?.map((row, rowIndex) => {
                                    return (
                                        <tr key={rowIndex} className='tableBodyRow'>
                                            {/* <td>{getTripDetails(row)}</td> */}
                                            <td>{row?.userName ?? 'N/A'}</td>
                                            <td>{getReviewStars(row.rating)}</td>
                                            <td className='reviewComments ellipsisCell'>{row?.comment ?? 'N/A'}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                        <div className='responsiveCardContainer'>
                            {reviews?.map((row, rowIndex) => (
                                <div key={rowIndex} className='responsiveCard'>
                                    <div className='cardContent'>
                                        <p>{/* <strong>{tableHeader[0]}:</strong> {getTripDetails(row)} */}</p>
                                        <p>
                                            <strong>{tableHeader[1]}:</strong> {row?.userName ?? 'N/A'}
                                        </p>
                                        <p className='ratingCon'>
                                            <strong>{tableHeader[2]}:</strong> {getReviewStars(row.rating)}
                                        </p>
                                        <p>
                                            <strong>{tableHeader[3]}:</strong> {row?.comment ?? 'N/A'}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
                {/* {reviews.length > 10 && ( */}
                {/* <Pagination
                    paginationClick={paginationClick}
                    numberOfRows={totalData}
                    offSet={offSet}
                    pageNumber={pageNumber}
                    limit={limit}
                /> */}
                {/* )} */}
            </div>
        </>
    );
};

export default OrgActivityReviews;
